import React from 'react';
import SecurityIndex from '../components/SecurityIndex';
import Pageheader from '../utils/headerHelment';

const SecurityIndexPage = () => {
    return (
        <>
            <Pageheader title="LENS - Security Index" />
            <SecurityIndex />
        </>
    );
};

export default SecurityIndexPage;
